import { LoadingLayer } from '@/core/features';
import { useNavigationContextValue } from '@/core/features/a-dynamic-page/hooks/use-dynamic-page-query';

export default function MobileContentWrapper(props: React.PropsWithChildren<{ isPageLoading: boolean }>) {
    const navigationContext = useNavigationContextValue();

    return (
        <>
            {!navigationContext.disableLoadingAnimation && props.isPageLoading && <LoadingLayer />}
            {props.children}
        </>
    );
}
